export const new_token = `subscription new_token{
    new_token{
        need_password_update
        expiry
        language
        terms_of_use{
            id
            document
            document_en
        }
    }
}`;
